import './src/Core.js'
import './src/Tabs.js'
